import React from "react";
import Bg_menu from "../../assets/img/bg_menu.jpg";

function Roulette({ wallet, setWallet }) {
  // const url = "https://astounding-kringle-9d6001.netlify.app/";
  // const url = "http://localhost:3000/";
  const url = window.location.href;
  const change = () => {
    window.location.href = `${url}Roulette`;
  };
  return (
    <div id="roulette_m">
      {}
      <div
        style={{ maxWidth: "90vw", margin: "0 auto" }}
        className="mt-20px flex justify-center"
      >
        <div
          onClick={change}
          style={{ marginTop: "100px", cursor: "pointer" }}
          className="flex flex-col md:flex-row md:max-w-xl rounded-lg bg-white shadow-lg"
        >
          <img
            className=" w-full h-196 md:h-auto object-cover md:w-48 rounded-t-lg md:rounded-none md:rounded-l-lg"
            src={Bg_menu}
            alt=""
          />
          <div className="p-6 flex flex-col justify-start margin-top 200px">
            <h5 className="text-gray-900 text-xl font-medium mb-2">Roulette</h5>
            <p className="text-gray-700 text-base mb-4">
              The soul of Metasino, Roulette.
            </p>
            <p className="text-gray-600 text-xs">Last updated 3 mins ago</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Roulette;
